// js
import './script/gsap';
import './script/hamburger';

// scss
import '../scss/style.scss';

